// extracted by mini-css-extract-plugin
export default {"allActivitiesSection":"Activities_allActivitiesSection__h3wno","total":"Activities_total__0mBzU"};